"use client";

import { type ReactElement } from "react";
import {
  Button,
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  TooltipProvider,
} from "../..";
import { MessageCircleQuestion } from "lucide-react";
import { useTranslations } from "use-intl";

function PortalHeaderFeedback(): ReactElement {
  const t = useTranslations("global.Feedback");
  const url = "https://sondage.umontpellier.fr/ls/index.php/788137";

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            size="icon"
            variant="outline"
            aria-label={t("action")}
            className="size-8 rounded-full"
            asChild
          >
            <a href={url} target="_blank">
              <MessageCircleQuestion strokeWidth={1} size={16} />
            </a>
          </Button>
        </TooltipTrigger>
        <TooltipContent>{t("action")}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

export { PortalHeaderFeedback };
